
import { vertex_1 } from "../shaders/shader";
import { FboBase } from "./FboBase";

export class Poisson extends FboBase {
    constructor(props) {
        super({
            common: props.common,
            material: {
                vertexShader: vertex_1,
                fragmentShader: /*glsl */`precision highp float;
                    uniform sampler2D pressure;
                    uniform sampler2D divergence;
                    uniform vec2 px;
                    varying vec2 uv;

                    void main(){    
                        
                        float p0 = texture2D(pressure, uv+vec2(px.x * 2.0,  0)).r;
                        float p1 = texture2D(pressure, uv-vec2(px.x * 2.0, 0)).r;
                        float p2 = texture2D(pressure, uv+vec2(0, px.y * 2.0 )).r;
                        float p3 = texture2D(pressure, uv-vec2(0, px.y * 2.0 )).r;
                        float div = texture2D(divergence, uv).r;
                        
                        float newP = (p0 + p1 + p2 + p3) / 4.0 - div;
                        gl_FragColor = vec4(newP);
                }`,
                uniforms: {
                    boundarySpace: {
                        value: props.boundarySpace
                    },
                    pressure: {
                        value: props.dst_.texture
                    },
                    divergence: {
                        value: props.src.texture
                    },
                    px: {
                        value: props.cellScale
                    }
                }
            },
            output: props.dst,
            output0: props.dst_,
            output1: props.dst
        });
        this.init()
    }
    update({iterations: e}) {
        let t, i;

        for (var s = 0; s < e; s++){
            if(s % 2 == 0){
                t = this.props.output0;
                i = this.props.output1;
            }else{
                t = this.props.output1;
                i = this.props.output0;
            }
            this.uniforms.pressure.value = t.texture;
            this.props.output = i;
            super.update();
        }
            
        return i
    }
}